import { useEmpresa } from '@/context/empresa.context';

import type { ReactElement } from 'react';

const Emisor = (): ReactElement => {
	const { emisor } = useEmpresa();
    
	return (
		<div className='[ c-pnp-company__emisor ][ c-pnp-heading-h3 ]'>{ emisor?.nombre }</div>
	);
};

export default Emisor;
